import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { SectionHeading } from "../components/SectionHeading";
import { FAQS } from "../data/content";

export default function FAQ() {
  return (
    <div data-testid="faq-page" className="bg-bone">
      <section className="pt-28 lg:pt-36 pb-16 bg-charcoal">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="eyebrow text-gold mb-3">FAQ</div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-semibold text-white text-balance max-w-3xl">
            Questions? We've got answers.
          </h1>
        </div>
      </section>

      <section className="py-16 lg:py-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Accordion type="single" collapsible className="space-y-3">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`}
                className="rounded-2xl border border-slate-200 bg-white px-5">
                <AccordionTrigger className="text-left font-serif text-lg text-charcoal hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div className="mt-12 rounded-2xl bg-charcoal p-8 text-center">
            <h3 className="font-serif text-2xl text-white">Still have a question?</h3>
            <p className="mt-2 text-platinum">We're happy to help you plan the perfect experience.</p>
            <Link to="/contact" data-testid="faq-contact-cta"
              className="mt-6 inline-flex items-center gap-2 rounded-full bg-gold px-7 py-3.5 font-semibold text-charcoal hover:bg-gold-bright">
              Contact Taste of Platinum <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
